import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2 7.18203C2 5.56484 3.31484 4.25 4.93203 4.25H35.068C36.6852 4.25 38 5.56484 38 7.18203C38 7.85703 37.768 8.51094 37.3391 9.03125L25.625 23.4102V33.4789C25.625 34.7305 24.6055 35.75 23.3539 35.75C22.8406 35.75 22.3414 35.5742 21.9406 35.2578L15.4367 30.0969C14.7617 29.5625 14.375 28.7539 14.375 27.8961V23.4102L2.66094 9.03125C2.23203 8.51094 2 7.85703 2 7.18203ZM5.86719 7.625L17.3703 21.7437C17.6164 22.0461 17.75 22.4188 17.75 22.8125V27.6219L22.25 31.1938V22.8125C22.25 22.4258 22.3836 22.0461 22.6297 21.7437L34.1328 7.625H5.86719Z" })
});
export default SvgFilter;
